export const setupGlobalProperties = (app) => {
  app.config.globalProperties.$colors = {
    black: '#000000',
    white: '#FFFFFF',
    green: '#4BB450',
  };
};

export default setupGlobalProperties;
